import UserResults from "../Components/users/UserResults";
import UserSearch from "../Components/users/UserSearch";
function Home() {
  return (
    <>
      <UserSearch />
      <UserResults />
    </>
  );
}

export default Home;
